import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import SupplyAndDischargeLogForm from "./SupplyAndDischargeLogForm";

const ViewSupplyAndDischargeLog = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("id", id);

    post(ApiURL.ods_refrigerant_log_get, fd).then((res) => {
      if (res?.status == true) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  return (
    <>
      <h2>View Supply and Discharge Log</h2>
      <SupplyAndDischargeLogForm
        logs={[details]}
        readOnly
      />
    </>
  );
};

export default ViewSupplyAndDischargeLog;
